import { Controller } from "@hotwired/stimulus";

// The email page: choosing a template fills in its subject and message, replacing what was there. A template
// without a subject keeps a subject the analyst typed, but clears one an earlier template filled in, so it
// doesn't go out with an unrelated message. The picker keeps showing the template chosen.
export default class extends Controller {
  static targets = ["subject", "body"];

  useTemplate({ currentTarget }) {
    const option = currentTarget.selectedOptions[0];
    if (!option?.value) return;

    const { subject = "", body = "" } = option.dataset;
    if (subject || this.subjectTarget.value === this.templateSubject) this.subjectTarget.value = subject;
    this.templateSubject = subject;
    this.bodyTarget.value = body;
    this.bodyTarget.focus();
    this.bodyTarget.setSelectionRange(0, 0);
  }
}
